import {PageableParams} from "@core/models/pageable-params";
import {TablePagination} from "@core/models/table-pagination";
import {TableLazyLoadEvent} from "primeng/table";
import {RowsPerPageOptions} from '@core/models/page-options';

/**
 * Classe base para componentes que utilizam tabelas paginadas.
 * Deve ser estendida para implementar a ação ao alterar paginação.
 */
export abstract class Paginator {
  pagination: TablePagination = new TablePagination();
  sortBy?: string | string[];
  sortDirection?: number; // 1 = asc, -1 = desc
  options: number[] = RowsPerPageOptions;

  get displayFirst(): number {
    return this.pagination.totalItems === 0 ? 0 : this.pagination.first + 1;
  }

  get displayLast(): number {
    const last = this.pagination.first + this.pagination.rows;
    return last > this.pagination.totalItems ? this.pagination.totalItems : last;
  }

  /**
   * Constrói os parâmetros para requisição paginada.
   * @param event Evento de ordenação/filtro da tabela
   * @param filterFormValue Valores do formulário de filtros
   * @param showPaginator Indica se está sendo usado a paginação padrão ou virtualScroll
   * @param isFiltered Indica se existem filtros aplicados
   */
  protected buildPageableParams(
    event?: TableLazyLoadEvent,
    filterFormValue?: Record<string, any>,
    showPaginator?: boolean,
    isFiltered?: boolean,
  ): PageableParams {
    const params = new PageableParams();

    // ponto 1 virtual scroll
    if (event && showPaginator) {
      if (event.first && event.rows) {
        this.pagination.page = event.first / event.rows;
      } else {
        this.pagination.page = 0;
      }
      this.pagination.rows = event.rows ?? 10;
    }
    if (!showPaginator) {
      const first = event?.first ? Math.round(event?.first / 10) : 0;
      params.page = first < 0 ? 0 : first;
      this.pagination.page = params.page;
      params.size = 100;
    } else {
      params.page = this.pagination.page;
      params.size = this.pagination.rows;
    }

    if (event?.sortField) this.sortBy = event?.sortField;
    this.sortDirection = event?.sortOrder ?? this.sortDirection ?? 1;

    if (this.sortBy) {
      const direction = this.sortDirection === 1 ? 'asc' : 'desc';
      params.sort = [`${this.sortBy},${direction}`];
    }

    // Filtros
    if (filterFormValue) {
      params.filters = PageableParams.cleanFilters(filterFormValue, (this as any).dataTableColumns)
    }
    //
    // if (!PageableParams.areFiltersEmpty(params.filters) || params.sort.length > 0) {
    //   params.page = 0;
    // }

    return params;
  }

}
